import { graphql } from 'react-relay';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import type {
	preloadPageStatusQueryDataQuery$data,
	preloadPageStatusQueryDataQuery$variables,
} from './__generated__/preloadPageStatusQueryDataQuery.graphql.ts';

const PreloadPageStatusQuery = graphql`
	query preloadPageStatusQueryDataQuery($contentId: ID!) {
		content(id: $contentId, status: ["archived", "current"]) {
			nodes {
				id
				status
			}
		}
	}
`;

export function preloadPageStatusQuery(contentId: string): Promise<{
	data: preloadPageStatusQueryDataQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<preloadPageStatusQueryDataQuery$data, preloadPageStatusQueryDataQuery$variables>({
		query: PreloadPageStatusQuery,
		variables: {
			contentId,
		},
	});
}
